import React, { useContext, useEffect, useState, memo } from "react";
import Drawer from "@material-ui/core/Drawer";

import Picker from "bodycodi/cmap/app/components/common/picker";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// utils
import "../../js/date";

interface RollingYearSelectPop {
  activeMode?: "blue" | "black";
  onChange: Function;
  propYear?: any;
  minYear?: number;
  maxYear?: number;
}

function RollingYearSelectPop({
  activeMode = "blue",
  onChange,
  propYear,
  minYear,
  maxYear,
}: RollingYearSelectPop) {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [year, setYear] = useState<any>(new Date().getFullYear());

  useEffect(() => {
    !!propYear ? setYear(Number(propYear)) : setYear(new Date().getFullYear());
  }, [propYear]);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "",
      open: { rollingYearSelectPop: false },
    });
  };

  const handleChange = (obj: any) => {
    setYear(obj.value);
  };

  const handleConfirm = () => {
    onChange(year);
    handleClose();
  };

  const getList = () => {
    let min: number | undefined = 0,
      max: number | undefined = 0;

    min = !!minYear ? minYear : 2010;
    max = !!maxYear ? maxYear : 2030;

    const options = [];
    for (let i: number = min; i <= max; i++) {
      options.push({ value: i, text: i + "년" });
    }
    return (
      <Picker
        data={options}
        activeMode={activeMode}
        index={0}
        current={options.findIndex((el) => el.value === year)}
        onChange={(i: any, obj: any) => handleChange(obj)}
      />
    );
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.rollingYearSelectPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <PickerHeader title="날짜 선택" onClose={handleClose} />
      <div className="picker-body">
        <div className="picker-effect">
          <div className="picker-wrap">{getList()}</div>
        </div>
      </div>
      <div className="picker-footer">
        <div className="confirm-btn" color="#004FEC" onClick={handleConfirm}>
          확인
        </div>
      </div>
    </Drawer>
  );
}

export default memo(RollingYearSelectPop);
